module.exports = __webpack_public_path__ + "static/media/avatar.c361c192.svg";